import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const LineHeightUnit = z.enum(["Pixels", "Rem", "Percent", "Raw"]);

export const LineHeightValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const LineHeightTokenData = tokenAliasOrValue(LineHeightValue);

export type LineHeightUnit = z.infer<typeof LineHeightUnit>;
export type LineHeightValue = z.infer<typeof LineHeightValue>;
export type LineHeightTokenData = z.infer<typeof LineHeightTokenData>;
